/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditMentionsAuditMentionsReportsScheduleStatusMutationRequest, AuditMentionsAuditMentionsReportsScheduleStatusMutationResponse, AuditMentionsAuditMentionsReportsScheduleStatusQueryParams } from "../models/AuditMentionsAuditMentionsReportsScheduleStatus";

export function getAuditMentionsAuditMentionsReportsScheduleStatusUrl() {
  const res = { method: 'POST', url: `/audit-mentions/v1/reports/schedule-status` as const }
  return res
}

/**
 * @description Returns the schedule status report for mentions on a given date.
 * @summary Get mention schedule status report
 * {@link /audit-mentions/v1/reports/schedule-status}
 */
export async function auditMentionsAuditMentionsReportsScheduleStatus(data: AuditMentionsAuditMentionsReportsScheduleStatusMutationRequest, params: AuditMentionsAuditMentionsReportsScheduleStatusQueryParams, config: Partial<RequestConfig<AuditMentionsAuditMentionsReportsScheduleStatusMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<AuditMentionsAuditMentionsReportsScheduleStatusMutationResponse, ResponseErrorConfig<Error>, AuditMentionsAuditMentionsReportsScheduleStatusMutationRequest>({ method : "POST", url : getAuditMentionsAuditMentionsReportsScheduleStatusUrl().url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}